import { create } from 'zustand';

export const useCartStore = create((set) => ({
  items: [],
  
  addItem: (product) =>
    set((state) => {
      const existingItem = state.items.find((item) => item._id === product._id);
      if (existingItem) {
        return {
          items: state.items.map((item) =>
            item._id === product._id
              ? { ...item, quantity: item.quantity + (product.quantity || 1) }
              : item
          ),
        };
      }
      return { items: [...state.items, { ...product, quantity: product.quantity || 1 }] };
    }),

  removeItem: (productId) =>
    set((state) => ({
      items: state.items.filter((item) => item._id !== productId),
    })),

  updateQuantity: (productId, quantity) =>
    set((state) => ({
      items: state.items.map((item) =>
        item._id === productId ? { ...item, quantity } : item
      ),
    })),

  clearCart: () => set({ items: [] }),

  getTotalPrice: () => {
    const state = useCartStore.getState();
    return state.items.reduce((total, item) => total + item.price * item.quantity, 0);
  },
}));
